<template>
    <div :class="dropZoneClassList">
        <div :class="s.dropZoneContainer">
            <span :class="s.dropZoneTitle">Перетащите файл сюда</span>
            <br>
            <span :class="s.info">Максимальный размер: {{ maxFileSizeForUploadingStr }}</span>
            <form :class="[s.uploadForm, s.dropZoneForm]">
                <label>
                    <span :class="s.uploadFormButton">Выберите файл</span>
                    <input type="file" :multiple="true" @change="$emit('change', $event.target.files)" />
                </label>
            </form>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import style from "./style.module.scss";

export default Vue.extend({
    name: "drop-zone",
    components: {},
    props: {
        maxFileSizeForUploading: Number,
    },
    mounted() {
        const dropZone = this.$el.firstElementChild;

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        const allEvenetNames = ["dragenter", "dragover", "dragleave", "drop"];
        const activeEventNames = ["dragenter", "dragover"];
        const passiveEventNames = ["dragleave", "drop"];

        allEvenetNames.forEach((eventName) => {
            dropZone?.addEventListener(eventName, preventDefaults, false);
        });

        activeEventNames.forEach((eventName) => {
            dropZone?.addEventListener(
                eventName,
                () => {
                    this.dropZoneActive = true;
                },
                false
            );
        });

        passiveEventNames.forEach((eventName) => {
            dropZone?.addEventListener(
                eventName,
                () => {
                    this.dropZoneActive = false;
                },
                false
            );
        });

        dropZone?.addEventListener(
            "drop",
            (e) => {
                // TODO проблема с типом события. у Event нет свойства dataTransfer
                this.$emit("change", e.dataTransfer.files);
            },
            false
        );
    },
    data() {
        return {
            s: style,
            dropZoneActive: false,
        };
    },
    methods: {},
    computed: {
        dropZoneClassList() {
            const classList = [this.s.dropZone];

            if (this.dropZoneActive) {
                classList.push(this.s.dropZoneActive);
            }

            return classList;
        },
        maxFileSizeForUploadingStr() {
            const size = this.maxFileSizeForUploading / 1024 / 1024;
            return (Number.isInteger(size) ? size : size.toFixed(2)).toString() + "Мб";
        }
    },
});
</script>
